"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _lodash = _interopRequireDefault(require("lodash"));
//
//
//
//
//
//
//
//
//
//
//
//
/** package */
var _default = exports.default = {
  props: {
    className: {
      type: String,
      default: ''
    },
    scrollInitTime: {
      type: Number,
      default: 0
    },
    // 是否需要nav导航，不需要则不初始化nav功能
    needNav: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      stepPageHeight: this.initStepPageHeight(),
      slider_dom: '_scroll_dom',
      slider_item: '_scroll_item',
      ctHeightList: [],
      // 每个内容块高度
      navActive: null,
      slderTimer: null,
      isClick: false
    };
  },
  computed: {
    _CtClassName: function _CtClassName() {
      return ".".concat(this.slider_item);
    }
  },
  watch: {
    scrollInitTime: {
      handler: function handler(val, oldVal) {
        if (val !== oldVal) {
          this.initScroll();
        }
      }
    }
  },
  mounted: function mounted() {
    this.initScroll();
    window.addEventListener('resize', _lodash.default.debounce(this.resizeInit, 300));
  },
  beforeDestroy: function beforeDestroy() {
    // console.log('beforeDestroy')
    window.removeEventListener('resize', _lodash.default.debounce(this.resizeInit, 300));
  },
  methods: {
    // resize
    resizeInit: function resizeInit() {
      this.stepPageHeight = this.initStepPageHeight();
    },
    // 初始化页面高度
    initStepPageHeight: function initStepPageHeight() {
      var clientHeight = document.documentElement.clientHeight;
      return clientHeight - 220;
    },
    // 初始化scroll，标记高度
    initScroll: function initScroll() {
      var _this = this;
      if (!this.needNav) {
        return false;
      }
      console.log('scroll init');
      this._slider_resetSide();
      this.navActive = 0;
      // 获取每个大div的offsetTop
      this.ctHeightList = [];
      var ScrollDOM = this.$refs['slider_dom'];
      var diff = ScrollDOM.offsetTop;
      var elementArr = document.querySelectorAll(this._CtClassName);
      elementArr.forEach(function (item, index) {
        var offsetTop = elementArr[index] ? elementArr[index].offsetTop : 0;
        _this.ctHeightList.push({
          offsetTop: offsetTop - diff || 0
        });
        // console.log(offsetTop, diff)
      });
    },
    // 滚动方法
    _scrollSmoothTo: function _scrollSmoothTo(position) {
      var ScrollDOM = this.$refs['slider_dom'];
      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function (callback, element) {
          return setTimeout(callback, 17);
        };
      }
      // 当前滚动高度
      var scrollTop = ScrollDOM.scrollTop;
      // 滚动step方法
      var _step = function step() {
        // 距离目标滚动距离
        var distance = position - scrollTop;
        // 目标滚动位置
        scrollTop = scrollTop + distance / 5;
        if (Math.abs(distance) < 1) {
          ScrollDOM.scrollTo({
            top: position
          });
        } else {
          ScrollDOM.scrollTo({
            top: scrollTop
          });
          requestAnimationFrame(_step);
        }
      };
      _step();
    },
    // 侧边栏点击
    _slider_handleClick: function _slider_handleClick(index) {
      var _this2 = this;
      this.isClick = true;
      this._slider_resetSide();
      var element = document.querySelectorAll(this._CtClassName)[index];
      // 让id为content${index}的元素滚动到浏览器窗口的可视区域内
      // element && element.scrollIntoView()
      if (element) {
        clearTimeout(this.slderTimer);
        this.slderTimer = setTimeout(function () {
          _this2.$nextTick(function () {
            _this2.navActive = index;
            _this2._scrollSmoothTo(element.offsetTop);
          });
        }, 200);
      }
    },
    // 重置侧边栏选中
    _slider_resetSide: function _slider_resetSide() {
      this.navActive = null;
    },
    // 滚动事件触发
    slider_handleScroll: function slider_handleScroll() {
      var _this3 = this;
      var ScrollDOM = this.$refs['slider_dom'];
      var slider_box = this.$refs['slider_box'];
      var scrollTop = ScrollDOM.scrollTop; // 获取滚动条位置
      if (this.isClick) {
        this.isClick = false;
        return;
      }
      this.ctHeightList.some(function (_, i) {
        // 最后一个可能无法触发
        if (slider_box.clientHeight - scrollTop - _this3.stepPageHeight < 30) {
          _this3.navActive = _this3.ctHeightList.length - 1;
        } else if (scrollTop >= _this3.ctHeightList[i].offsetTop && scrollTop < _this3.ctHeightList[i + 1].offsetTop) {
          _this3._slider_resetSide();
          _this3.navActive = i;
          return true;
        }
      });
    }
  }
};